import reducer from "./reducer";
export { default as Queries } from "./components/index";
export { default as queriesReducerName } from "./constants";
export default reducer;
